/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportResponse } from '../../models/report-response';
import { ReportToGenerate } from '../../models/report-to-generate';

export interface PdfGeneratorGenerate$Params {
      body: ReportToGenerate
}

export function pdfGeneratorGenerate(http: HttpClient, rootUrl: string, params: PdfGeneratorGenerate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportResponse>> {
  const rb = new RequestBuilder(rootUrl, pdfGeneratorGenerate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportResponse>;
    })
  );
}

pdfGeneratorGenerate.PATH = '/pdf-generator/generate';
